import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsComponent } from '../icons/icons.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'vti-breadcrumbs',
  standalone: true,
  imports: [CommonModule, RouterLink, IconsComponent],
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  public homeLink = input<string>('');
}
